import { userService } from '@/services';
import { FormDataUserPermissionSettingDialog } from '@/form/form-data/FormDataUserPermissionSettingDialog';
import { ServiceDataPutUserPermissionSetting } from '@/service-data/user-permission-setting/ServiceDataPutUserPermissionSetting';
import { UserPermissionSettingVM } from '@/view-model/user-management/UserPermissionSettingVM';
import { UPDATE_USER_PERMISSION, USER_PERMISSION_SETTING, } from '@/constants/userPermission';
import { mutationType } from './mutations';
const actionType = {
    /** 다이얼로그 열기/닫기 */
    setDialogDetail: 'setDialogDetail',
    /** 사용자 권한 조회 */
    getUserPermissionList: 'getUserPermissionList',
    /** 사용자 권한 목록 붙여넣기 */
    pasteUserPermissionList: 'pasteUserPermissionList',
    /** 사용자 권한 업데이트 */
    updateUserPermission: 'updateUserPermission',
    /** 사용자 권한 PUT */
    putUserPermissionList: 'putUserPermissionList',
    /** 사용자 권한 목록 초기화 */
    resetUserPermissionList: 'resetUserPermissionList',
    /** 전체 초기화 */
    resetStore: 'resetStore',
};
const actions = {
    [actionType.setDialogDetail]({ commit }, payload) {
        commit(mutationType.SET_DIALOG_DETAIL, payload);
    },
    async [actionType.getUserPermissionList]({ commit, state }) {
        const { userInfo, } = state.dialogDetail;
        if (!userInfo) {
            return;
        }
        const { userId, } = userInfo;
        if (!userId) {
            return;
        }
        try {
            const response = await userService.getUserPermissionList(userId);
            const dataList = response.data.map((item) => new UserPermissionSettingVM(item));
            commit(mutationType.GET_USER_PERMISSION_LIST, dataList);
        }
        catch (error) {
            console.log('getUserPermissionList', error);
        }
    },
    [actionType.pasteUserPermissionList]({ commit, getters, state }, payload) {
        // sessionStorage를 조작 할 경우를 대비한 아주 작은 확인
        const isSameLength = payload.length === state.userPermissionList.length;
        if (!isSameLength) {
            throw new Error();
        }
        const { getterIsChange0502PermissionAvailable, } = getters;
        // 0502 권한 확인 수정 권한 없으면 현재 값 유지
        // https://www.notion.so/barogohq/a126b89322f74e4c823e8bd47df666af?pvs=4#f6cc1c0a94ae4266a8505786b42e2c91
        if (getterIsChange0502PermissionAvailable) {
            commit(mutationType.PASTE_USER_PERMISSION_LIST, payload);
            return;
        }
        const index = payload.findIndex((item) => item.code === USER_PERMISSION_SETTING);
        if (index === -1) {
            throw new Error();
        }
        payload[index].setIsAuthorized(state.userPermissionList[index].isAuthorized);
        const index2 = payload.findIndex((item) => item.code === UPDATE_USER_PERMISSION);
        if (index === -1) {
            throw new Error();
        }
        payload[index2].setIsAuthorized(state.userPermissionList[index2].isAuthorized);
        commit(mutationType.PASTE_USER_PERMISSION_LIST, payload);
    },
    [actionType.updateUserPermission]({ commit }, payload) {
        // 상위 권한 변경시
        if (payload.isDepth2) {
            commit(mutationType.UPDATE_USER_PERMISSION_LIST, payload);
            return;
        }
        // 하위 권한 변경시
        commit(mutationType.UPDATE_USER_PERMISSION, payload);
    },
    async [actionType.putUserPermissionList]({ state }) {
        const { userPermissionList, dialogDetail, } = state;
        if (!dialogDetail.userInfo?.userId) {
            return;
        }
        const formData = new FormDataUserPermissionSettingDialog(userPermissionList);
        const serviceDataPut = new ServiceDataPutUserPermissionSetting(formData);
        await userService.putUserPermissionList(dialogDetail.userInfo.userId, serviceDataPut.createReqBody());
    },
    [actionType.resetUserPermissionList]({ commit }) {
        commit(mutationType.RESET_USER_PERMISSION_LIST);
    },
    [actionType.resetStore]({ commit }) {
        commit(mutationType.RESET_STORE);
    },
};
export default actions;
